export default {"src":"/_next/static/media/s-3-buckets.2e105ad4.svg","height":512,"width":448,"blurWidth":0,"blurHeight":0};